export default "__VITE_ASSET__329c2dec__"